import * as React from "react";

type Prop = {
    isMobile? : boolean
}

const ConsultationTable : React.FC<Prop> = ({isMobile = false}) => {

    const closedDate = () => {
        if (isMobile) {
            return (
            <div className={"closed-days"}>
                <div className={"content"}>休診日：日曜・祝日・水曜・土曜午後</div>
            </div>
            );
        }
        return (
            <div className={"closed-days"}>
                <div className={"title"}>休診日</div>
                <div className={"content"}>日曜・祝日・水曜・土曜午後</div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <table className={"consultation-hours"}>
                <tbody>
                    <tr>
                        <td/>
                        <td>月</td>
                        <td>火</td>
                        <td>水</td>
                        <td>木</td>
                        <td>金</td>
                        <td>土</td>
                    </tr>
                    <tr>
                        <td>
                            午前
                            <div className={"hour"}>9:00～12:00</div>
                        </td>
                        <td className={"content"}>●</td>
                        <td className={"content"}>●</td>
                        <td className={"content"}>／</td>
                        <td className={"content"}>●</td>
                        <td className={"content"}>●</td>
                        <td className={"content"}>●</td>
                    </tr>
                    <tr>
                        <td>
                            検査・手術
                            <div className={"hour"}>13:00～16:00</div>
                        </td>
                        <td className={"content"}>※</td>
                        <td className={"content"}>※</td>
                        <td className={"content"}>／</td>
                        <td className={"content"}>※</td>
                        <td className={"content"}>※</td>
                        <td className={"content"}>／</td>
                    </tr>
                    <tr>
                        <td>
                            午後
                            <div className={"hour"}>16:00～19:00</div>
                        </td>
                        <td className={"content"}>●</td>
                        <td className={"content"}>●</td>
                        <td className={"content"}>／</td>
                        <td className={"content"}>●</td>
                        <td className={"content"}>●</td>
                        <td className={"content"}>／</td>
                    </tr>
                </tbody>
            </table>
            {closedDate()}
        </React.Fragment>
    );
}

export default ConsultationTable;
